import React from "react";
import MarketingPartnerDataList from "./MarketingPartnerDataList";
import MarketingPartnerEditForm from "./MarketingPartnerEditForm";

///////////////////// LIST ALL MARKETING PARTNERS /////////////////////
export const MarketingPartnerList = props => <MarketingPartnerDataList {...props} />;

///////////////////// UPDATE MARKETING PARTNER /////////////////////
export const MarketingPartnerEdit = props => <MarketingPartnerEditForm {...props} />;



// WEBPACK FOOTER //
// ./src/containers/CRM/MarketingPartners/index.js